import { Card, Col, Row, Statistic, Typography } from 'antd';
import { workorderIndicatorItensOptions } from '../options';
import { useWorkOrderChartIndicators } from '@/core/domain/workorder/WorkOrdersChart/WorkOrdersChart.hooks';
import { WorkOrderChartFilter } from '@/core/domain/workorder/WorkOrdersChart/WorkOrdersChart.types';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  filter?: WorkOrderChartFilter;
}

export default function WorkOrderIndicatorsItensAmount(props: Props) {
  const { data, isLoading } = useWorkOrderChartIndicators(props.filter);

  return (
    <div>
      <Typography.Title level={4}>Valor por tipo do item</Typography.Title>

      <Row gutter={[24, 24]}>
        {workorderIndicatorItensOptions.map((item) => (
          <Col key={item.key} span={24} md={12} lg={8} xl={5}>
            <Card bordered style={{ borderRadius: 12 }} loading={isLoading}>
              <Statistic
                title={item.label}
                value={data ? data[item.key as keyof typeof data] : 0}
                valueStyle={{ fontSize: '1.4rem', paddingTop: 8 }}
                formatter={(value) => formatterPrice(Number(value))}
              />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
